module.exports = __webpack_public_path__ + "img/OKR.d83b9e00.png";